import { useQuery } from '@tanstack/react-query';

import { env } from '../utils/env';

export interface WorkshopsResult {
    workshop_occurrences: WorkshopOccurrence[];
}

export interface WorkshopOccurrence {
    id: number;
    physical_address: string;
    location_title: string;
    description: string;
    latitude: string;
    longitude: string;
    places_total: number;
    signups: number;
    show_lesson_time: string;
    cyclic_day: number | string;
    cyclic_hour: string;
    status: number;
    workshop_location_id: number;
    workshop_type_id: number;
    is_signup_allowed: number;
    allow_external_signups: number;
    payment_type: PaymentType;
    custom_group_name: null | string;
    special_price: null | string;
    free_lesson_active: boolean;
    free_lesson_text: null | string;
    free_lesson_description: null | string;
}

export enum PaymentType {
    KindergardenVatInvoice = 'kindergarden_vat_invoice',
    Parents = 'parents',
}

export const useWorkshops = ({
                                 franchiseId,
                                 levelId = '',
                             }: {
    franchiseId: string;
    levelId?: string;
}) => {
    const { data, isLoading, error } = useQuery<WorkshopsResult>({
        queryKey: ['workshops', franchiseId],
        queryFn: () =>
            fetch(
                `${env.API_URL}/franchises/${franchiseId}/workshops/${levelId}`,
            ).then((res) => res.json()),
    });

    return {
        workshops: data?.workshop_occurrences ?? [],
        isLoading,
        error,
    };
};
